import { Shopflow } from './index';

export enum SOUNDS {
  AUDIO_BEEP_DEFAULT = 1,
  AUDIO_ERROR_DEFAULT = 2,
  AUDIO_BEEP_UFO = 3,
  AUDIO_ERROR_UFO = 4,
}

export const useSound = () => {
  const playSound = (soundId: SOUNDS, isLoop: boolean = false) => {
    Shopflow.playSound({ soundId, isLoop });
  }

  return {
    playSound,
  }
}
